import { useRef, useState } from 'react';
import Form from '../Form/Form';
import './Comment.css';
import Info from './Info/Info';
import Score from './Score/Score';

const Comment = ({comment,currentUser,id,handleData})=>{
  
const isMe = currentUser.username === comment.user.username

const [isReplying,setIsReplying] = useState(()=>false);
const [isEditing,setIsEditing] = useState(()=>false);
const [newComment,setNewComment] = useState(comment.content);
const editable = useRef(null)

function handleReply(){
  setIsReplying(previsReplying=>!previsReplying)
}
function handleEdit(){
  //console.log("edit",isEditing)
  setIsEditing(prev=>!prev)
  //if(isEditing) editable.current.focus()
}
function Button(){
  return (<div className='button' onClick={()=>edit()}>
  UPDATE
</div>)
}


//console.log(isReplying)
function Reply(){
  return (
    <div className="reply" onClick={()=>handleReply()}>
      <img src="./images/icon-reply.svg" alt="reply"/>
      <p>Reply</p>
    </div>
  )
}
// useEffect(()=>{
//   console.log(editable.current.innerText )
  
// })

// useEffect(()=>{
// console.log(newComment)
// },[newComment])

function edit(){
  const data = JSON.parse(localStorage.getItem('data'))
  data.comments.forEach(element => {
    if(element.id===comment.id)
    element.content = newComment
    else{
      element.replies.forEach(rep=>{
        if(rep.id===comment.id)
        rep.content = newComment
      })
    }
  });
  localStorage.setItem('data',JSON.stringify(data))
  handleEdit()
  handleData()
}
function handleDelete(){
  //console.log("ciao")
  const data = JSON.parse(localStorage.getItem('data'))
  data.comments.forEach((element,index )=> {
    if(element.id===comment.id)
    data.comments.splice(index,1)
    else{
      element.replies.forEach((rep,ind,obj)=>{
        if(rep.id===comment.id)
       obj.splice(ind,1)
      })
    }
  });
  localStorage.setItem('data',JSON.stringify(data))
  handleData()
}
function Update(){
  return (
    <div className="update">
      <div className="reply" onClick={()=>handleDelete()}>
        <img src="./images/icon-delete.svg" alt="delete" />
        <p>Delete</p>
      </div>
      <div className="reply" onClick={()=>handleEdit()}>
        <img src="./images/icon-edit.svg" alt="edit"/>
        <p>Edit</p>
      </div>
  </div>
  )
} 

function Toggle(){
  return isMe ? <Update/> : <Reply />
}

return (
  <>
    <div className="comment">
        <Score vote={comment.score} id={comment.id}/>
        <div className="content">
          <div className="header">
            <Info comment={comment} isMe={isMe}/>
            <Toggle />
          </div>
          <div className={isEditing ? "text focus":"text"}  >
            {comment.replyingTo &&  <span className="answer"  >@{comment.replyingTo+', '}</span>}
            { <span ref={editable} contentEditable={isEditing} suppressContentEditableWarning={true} onInput={e=>setNewComment(e.target.innerText)}>{comment.content}</span> }
          </div>
        </div>
        {isEditing &&<Button/>}
    </div>
    {isReplying && <Form user={currentUser} reply={true} name={comment.user.username} id={id} handleData ={handleData} handleReply={handleReply}/>}
  </>

)
}
export default Comment;